import { z } from "zod";
import { RouteAwardCollectionEntry } from "../challenge-awards.js";
import { CommunityAuthor } from "./author.js";
import { GetCommunityMeStatsResponse } from "./me-stats.js";
/** The member identifier used to look up a Community profile. */
export const CommunityMemberProfileParams = z.object({
    userId: z.string().uuid(),
});
/** Who the member is in the community, as the community store knows them. */
export const CommunityMemberProfileIdentity = z.object({
    author: CommunityAuthor,
    communityPosts: z.number().int().nonnegative(),
});
/**
 * A compact, company-scoped Community profile. Never private health data:
 * route progress and streak length are what colleagues already see on the
 * route map and the company award figures.
 */
export const CommunityMemberProfile = CommunityMemberProfileIdentity.extend({
    /**
     * All-time community counts, the same ones the member sees on their own
     * profile. Null when those counts could not be read: the profile still
     * returns, and a client shows the counts as unavailable.
     */
    activity: GetCommunityMeStatsResponse.nullable(),
    /**
     * Routes the member has walked, with their progress on each and when they
     * reached each milestone. The same entry shape as the member's own award
     * collection, so a client derives medals with one rule. Null when route
     * history could not be read.
     */
    awardRoutes: z.array(RouteAwardCollectionEntry).nullable(),
    /**
     * Best run of days meeting the step goal, for the streak medal's level.
     * Null when the streak could not be read.
     */
    bestStreakDays: z.number().int().nonnegative().nullable(),
});
export const GetCommunityMemberProfileResponse = CommunityMemberProfile;
//# sourceMappingURL=member-profile.js.map